export var ModalActionKind;
(function (ModalActionKind) {
    ModalActionKind["OpenAddBooking"] = "OpenAddBooking";
    ModalActionKind["CloseAddBooking"] = "CloseAddBooking";
    ModalActionKind["OpenBookingSummary"] = "OpenBookingSummary";
    ModalActionKind["CloseBookingSummary"] = "CloseBookingSummary";
    ModalActionKind["OpenPromptAddAbsence"] = "OpenPromptAddAbsence";
    ModalActionKind["ClosePromptAddAbsence"] = "ClosePromptAddAbsence";
    ModalActionKind["OpenAddAbsenceStepper"] = "OpenAddAbsenceStepper";
    ModalActionKind["CloseAddAbsenceStepper"] = "CloseAddAbsenceStepper";
})(ModalActionKind || (ModalActionKind = {}));
